import styled from 'styled-components';
import { generateContentIconStyle } from '../../icons';

export const Card = styled.div`
  border-radius: 32px;
  background: ${props =>
    props.unavailable
      ? props.theme.colors.background.disabled
      : props.theme.colors.background.lightest};
  border: 2px solid
    ${props =>
      props.checked ? props.theme.colors.secondary.egg : 'transparent'};
  display: inline-flex;
  flex-direction: column;
  user-select: none;
  overflow: hidden; /* prevent overflow on rounded corners */
  position: relative; /* allow absolute positioning of child elements */
  width: 240px;
  max-width: 280px;
`;
export const CardContent = styled.div`
  display: inline-flex;
  flex-direction: column;
  flex: 1;
  padding: ${props => props.theme.spacing(4, 4, 0)};
  justify-content: space-between;
  margin-bottom: ${props => props.theme.spacing(4)};
`;

export const Image = styled.img`
  object-fit: cover;
  max-height: 164px;
  filter: ${props => props.unavailable && 'grayscale(100%) brightness(93%)'};
`;

export const MoreDetails = styled.button`
  align-items: center;
  display: flex;
  border: none;
  padding: 0;
  visibility: ${props => (props.unavailable ? 'hidden' : 'visible')};
  background-color: transparent;
  ${({ theme }) => theme.typography.bodyBold}
  color:${props => props.theme.colors.text.secondary};
  text-align: left;
  margin-bottom: ${({ theme }) => theme.spacing(4)};

  svg {
    margin-left: ${props => props.theme.spacing(1)};
  }
`;

export const Pill = styled.div`
  display: ${props => (props.unavailable ? 'none' : 'inline-block')};
  text-transform: uppercase;
  font-size: 12px;
  line-height: 14.4px;
  ${props => props.theme.fontFamily.condensed};
  background-color: ${props =>
    props.type === 'benefit'
      ? props.theme.colors.text.secondary
      : props.theme.colors.hero.blueberry};
  color: ${props => props.theme.colors.text.lightest};
  padding: 1px 8px;
  border-radius: 32px;
  margin-right: ${({ theme }) => theme.spacing(3)};
`;

export const Info = styled.div`
  color: ${({ theme }) => theme.colors.text.primary};
  padding-top: ${({ theme }) => theme.spacing(2)};
`;

export const Name = styled.div`
  ${({ theme }) => theme.typography.subheading1}
  ${({ theme }) => theme.fontFamily.condensed}
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  text-transform: uppercase;
`;

export const StrikeThroughPrice = styled.span`
  ${({ theme }) => theme.typography.body}
  ${({ theme }) => theme.fontFamily.condensed}
  margin-right: ${({ theme }) => theme.spacing(1)};
  text-decoration-line: line-through;
  opacity: 0.4;
  text-transform: capitalize;
`;

export const DisplayedPrice = styled.span`
  ${({ theme }) => theme.typography.body}
  ${({ theme }) => theme.fontFamily.condensed}
	margin-right: ${({ theme }) => theme.spacing(1)};
`;

export const Description = styled.div`
  ${({ theme }) => theme.typography.body}
  margin: ${({ theme }) => theme.spacing(1)} 0;
`;

export const CheckboxContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  max-width: 214px;
  border-radius: 200px;
  padding: ${props => props.theme.spacing(4)};
  background: ${props =>
    props.checked
      ? props.theme.colors.secondary.egg
      : props.theme.colors.background.base};
  background: ${props => props.unavailable && 'transparent'};
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  ${({ theme }) => theme.typography.body}
  &:hover {
    cursor: pointer;
  }
  &::before {
    ${props =>
      props.checked
        ? generateContentIconStyle('radiobox-marked')
        : generateContentIconStyle('radiobox-blank')};
    ${props => props.unavailable && generateContentIconStyle('close')};
    width: 16px;
    height: 16px;
    background: ${props =>
      props.checked
        ? props.theme.colors.text.primary
        : props.theme.colors.border.dark};
    margin-right: ${props =>
      props.unavailable ? props.theme.spacing(5) : props.theme.spacing(12)};
  }
  &::after {
    content: '';
    border-radius: 32px;
    position: absolute;
    left: 10%;
    bottom: 3%;
    height: 10%;
    width: 80%;
  }
`;
